<template>

<div class="controls">
	<h5 class="mbs" v-if="label">{{label}}</h5>
	<div>
		<i class="fal fa-circle-notch fa-spin fa-fw" v-if="loading"></i>
	</div>

	<div v-if="disableSwitch">
		<i class="fal fa-badge-check fa-2x" style="color: #53c0b9;"></i>
	</div>

	<div v-else>
		<div class="switch round tiny">
			<input type="checkbox" :name="setting || feature" :id="setting || feature" v-model="status" v-on:click="toggle">
			<label :for="setting || feature" class="right inline"></label>
		</div>
	</div>
</div>



</template>


<script>
'use strict';
	export default {
		name: 'ToggleWithLabel',
		data() {
			return {
				status: '',
				loading: true
			}
		},

		props: {
			setting: {
				required: false,
				type: String,
				default: function() {
					return this.$root.$el.dataset.settingName
				}

			},
			feature: {
				required: false,
				type: String,
				default: function() {
					return this.$root.$el.dataset.featureName
				}

			},
			label : {
				required: false,
				type: String,
				default: function() {
					return this.$root.$el.dataset.settingLabel
				}
			},
			byline : {
				required: false,
				type: String,
				default: function() {
					return this.$root.$el.dataset.byline
				}
			},
			disableIfToggledOn : {
				required: false,
				type: Boolean
			}

		},

		methods: {

			async getSetting() {
				try {


					this.loading = true;
					const url = Routing.generate('ApiBundle_get_setting', {setting: this.setting});
					const request = new Request(url, {
						method: 'GET',
						credentials: 'same-origin'
					});

					const setting = await fetch(request);
					const settingJson = await setting.json();
					this.loading = false;
					this.status = !!parseInt(settingJson.data);
				} catch(error) {
					console.error(error);
				}

			},

			async toggleSetting() {
				try {
					this.loading = true;
					const url = Routing.generate('ApiBundle_toggle_setting', {setting: this.setting});
					const request = new Request(url, {
						method: 'POST',
						credentials: 'same-origin'
					});

					const statusRequest = await fetch(request);
					const statusJson = await statusRequest.json();
					this.loading = false;
					this.status = !!parseInt(statusJson.data);
				} catch(error) {
					console.error(error);
				}


			},


			async getFeature() {
				try {
					this.loading = true;
					const url = Routing.generate('ApiBundle_get_feature', {feature: this.feature});
					const request = new Request(url, {
						method: 'GET',
						credentials: 'same-origin'
					});

					const feature = await fetch(request);
					const featureJson = await feature.json();
					this.loading = false;

					this.parseStatus(featureJson.data);

				} catch(error) {
					console.error(error);
				}

			},


			async toggleFeature() {
				try {
					this.loading = true;
					const url = Routing.generate('ApiBundle_toggle_feature', {feature: this.feature});
					const request = new Request(url, {
						method: 'POST',
						credentials: 'same-origin'
					});

					const featureRequest = await fetch(request);
					const featureJson = await featureRequest.json();
					this.loading = false;
					this.parseStatus(featureJson.data);
				} catch(error) {
					console.error(error);
				}


			},

			parseStatus(response) {
					if(response == 0) {
						this.status = false;
					} else if(response == 1) {
						this.status = true;
					} else {
						this.status = response;
					}
			},

			get() {
				this.feature ? this.getFeature() : this.getSetting();
			},

			toggle() {
				this.feature ? this.toggleFeature() : this.toggleSetting();
			}



		},

		computed: {
			booleanStatus() {
				if(this.status == 1) {
					return true;
				} else {
					return false;
				}
			},

			dynamicLabel() {
				if(this.status) {
					return `You have ${this.label} switched on!`;
				} else {
					return this.label;
				}
			},
			disableSwitch() {
				return this.disableIfToggledOn && this.status;
			}

		},

		components: {

		},

		beforeMount() {
		},

		mounted() {
			this.get();
		},
		created() {

		}

	};
</script>


<style scoped>

[v-cloak] {
	display: none;
}

h6 {
	font-size: 0.7rem;
	color: #737373;
}

.grid-row {
	display: grid;
	grid-template-columns: 8fr 4fr;
	align-items: center;
}

.controls {
	display: grid;
	grid-template-columns: 1fr 1fr;
}

</style>
